import PlayArrowRoundedIcon from '@mui/icons-material/PlayArrowRounded';

export const StartTimeTrackingIcon = PlayArrowRoundedIcon;
